<div class="app-dialog dc-share">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2 id="dc-wallets-title">{{ data.name }}</h2>
      @if (data.email) {
        <p class="app-dialog__subtitle">{{ data.email }}</p>
      }
    </div>
    <button
      type="button"
      mat-icon-button
      (click)="close()"
      [attr.aria-label]="'digitalCard.owner.closeModal' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    @if (loading) {
      <div class="dc-share__loading">
        <app-loading [text]="'digitalCard.owner.loading' | translate"></app-loading>
      </div>
    } @else {
      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ "digitalCards.walletsSmsTitle" | translate }}</h3>
        </header>

        <div class="dc-wallets__send-row">
          <mat-form-field appearance="outline" class="dc-wallets__field" subscriptSizing="dynamic">
            <mat-label>{{ "digitalCards.walletsEmailLabel" | translate }}</mat-label>
            <input matInput [value]="recipientEmail || ''" readonly autocomplete="email" />
          </mat-form-field>

          <button
            type="button"
            class="dc-share__row dc-wallets__send-btn"
            (click)="sendMessage()"
            [disabled]="sending || !entryUrl || !recipientEmail"
          >
            <span class="dc-share__row-icon dc-share__row-icon--send">
              @if (sending) {
                <mat-spinner diameter="18"></mat-spinner>
              } @else {
                <mat-icon>send</mat-icon>
              }
            </span>
            <span class="dc-share__row-label">
              {{ "digitalCards.walletsSendSms" | translate }}
            </span>
          </button>
        </div>
        @if (sent) {
          <p class="dc-wallets__sent-hint">
            {{ "digitalCards.walletsSmsSent" | translate }}
          </p>
        }
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ "digitalCards.walletsLinkTitle" | translate }}</h3>
        </header>

        <div class="dc-share__rows">
          <button
            type="button"
            class="dc-share__row"
            (click)="copyEntryLink()"
            [disabled]="!entryUrl"
          >
            <span class="dc-share__row-icon">
              <mat-icon>link</mat-icon>
            </span>
            <span class="dc-share__row-label">
              {{ "digitalCards.walletsCopyEntryLink" | translate }}
            </span>
          </button>
        </div>
      </section>
    }
  </div>
</div>
